<template>
  <div class="text-center pb-4">
    {{ bp('textSearchNoResults') }}
  </div>
</template>
<script>
export default {
  name: 'PlpNoResults',
};
</script>
